import { gql, TypedDocumentNode } from '@apollo/client';

/**
 * NCP-4701: route customer document downloads through an audited backend query
 * instead of opening the presigned S3 link directly. The backend resolver
 * (`openCustomerDocument`) records the access event and returns a fresh
 * (server-generated) link to open.
 *
 * NOTE: this resolver + schema field is added in a SEPARATE payment-backend
 * PR (NCP-4701 backend) that is not yet deployed. Because of that, GraphQL
 * codegen against the live schema does NOT include `openCustomerDocument`, so
 * the query document and its types are hand-defined here rather than generated.
 * Once the backend PR is deployed, this can be migrated to the generated SDK.
 */

export interface OpenCustomerDocumentQuery {
  openCustomerDocument: string | null;
}

export interface OpenCustomerDocumentQueryVariables {
  policyId: string;
  documentType: string;
}

export const OPEN_CUSTOMER_DOCUMENT: TypedDocumentNode<
  OpenCustomerDocumentQuery,
  OpenCustomerDocumentQueryVariables
> = gql`
  query openCustomerDocument($policyId: String!, $documentType: String!) {
    openCustomerDocument(policyId: $policyId, documentType: $documentType)
  }
`;
